import { render, staticRenderFns } from "./TrustedIcon.vue?vue&type=template&id=6ff195bc&scoped=true"
import script from "./TrustedIcon.vue?vue&type=script&lang=js"
export * from "./TrustedIcon.vue?vue&type=script&lang=js"
import style0 from "./TrustedIcon.vue?vue&type=style&index=0&id=6ff195bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff195bc",
  null
  
)

export default component.exports